import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { finishYoutubeOauth } from '../../services/contentAiService';

export default function YouTubeOAuthCallback() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('Processando...');
  const [canRetry, setCanRetry] = useState(false);

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search || '');
      const state = params.get('state');
      const code = params.get('code');
      const redirectUri = `${window.location.origin}/youtube/oauth-callback`;
      if (!state || !code) {
        setStatus('Callback inválido (state/code ausentes)');
        setLoading(false);
        setCanRetry(false);
        return;
      }
      try {
        setStatus('Finalizando OAuth...');
        const resp = await Promise.race([
          finishYoutubeOauth({ state, code, redirectUri }),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Tempo esgotado ao finalizar OAuth (timeout)')), 60000))
        ]);
        toast.success('YouTube conectado');
        const name = resp?.data?.name || resp?.data?.data?.name || null;
        setStatus(name ? `Conectado com sucesso (${name})` : 'Conectado com sucesso');
        setCanRetry(false);
      } catch (e) {
        toast.error(e?.message || 'Falha ao finalizar OAuth');
        setStatus(e?.message || 'Falha ao finalizar OAuth');
        setCanRetry(true);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  return (
    <Box p={2} display="grid" gap={2}>
      <Typography variant="h5">YouTube OAuth</Typography>
      <Typography>{status}</Typography>
      <Box display="flex" gap={2} flexWrap="wrap">
        <Button
          variant="outlined"
          onClick={() => window.location.reload()}
          disabled={loading || !canRetry}
        >
          Tentar novamente
        </Button>
        <Button variant="contained" onClick={() => navigate('/youtube')} disabled={loading}>Voltar</Button>
      </Box>
    </Box>
  );
}
